<script lang="ts" setup>
import { useI18n } from "vue-i18n";
import type { VuetifyRule } from "@/types/props";
import { useValidation } from "@/composables/useValidation";

const model = defineModel<string | null>({ default: null });

const { t } = useI18n();
const { emailValidator } = useValidation();

const props = withDefaults(
  defineProps<{
    rules?: VuetifyRule[];
    required?: boolean;
    label?: string;
  }>(),
  {
    rules: () => [],
    required: true,
    label: undefined,
  },
);

function validationRules(email: string | null): boolean | string {
  if (!props.required && !email) {
    return true;
  }

  return emailValidator(email ?? "");
}
</script>

<template>
  <v-text-field
    v-model="model"
    :class="{
      required: props.required,
    }"
    :label="props.label ?? t('general.email')"
    :rules="[...props.rules, validationRules]"
    autocomplete="off"
    color="primary"
    density="compact"
    variant="outlined"
  />
</template>
